import { makeVar } from '@apollo/client'

import { UnlinkedBsbPaymentInstrument } from 'hooks/paymentInstruments/PaymentInstruments.types'

export const rvUnlinkedPaymentInstruments = makeVar<
  UnlinkedBsbPaymentInstrument[]
>([])
